// this file is generated by update_shopify_store_data.py at 2026-06-22 20:30:53.736952
var courses = [
    {
        "course_id": "F422F213-089B-EC11-80EE-005056B142B5",
        "course_version": 7,
        "name": "Emergency Severity Index 3.0",
        "course_type": 1,
        "author_information": "",
        "description": "Emergency Severity Index has been widely adopted in the United States and growing globally. This course includes the Emergency Severity Index Handbook Version 5, appropriate application of the ESI algorithm, scenarios and examples for each ESI level, and additional pediatric ESI questions that are optional.\r\n\r\nDisclosure: The planners and presenters of this course have no relevant financial relationships with ineligible companies to disclose. Learners will be awarded 5 CNE contact hours upon a complete review of the course, completion of the post exam and submitting an evaluation. Course expires 12/31/2028.",
        "learning_objectives_html": "<p>Upon completion of this course, learners will be able to:</p>\r\n<ul>\r\n    <li>Identify high-risk vital signs and patient presentations that require an ESI level 1 or 2 acuity assignment.</li>\r\n    <li>Correctly apply ESI to assign an accurate acuity level.</li>\r\n    <li>Recognize the criteria for assigning each different ESI level.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "2FE9D9DF-655E-EF11-998C-005056A7DAD4",
                "course_category_name": "ENA: Clinical Practice - Novice Pathway [manage subscribers with Content Package]",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A03AF2B6-516C-EE11-9984-005056A76043",
                "course_category_name": "ENA - Triage Curriculum",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5A00DCAC-655E-EF11-998C-005056A7DAD4",
                "course_category_name": "ENA - Novice Pathway",
                "is_system_course_category": null
            },
            {
                "course_category_id": "784327F3-57C5-F011-99A3-005056A70840",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Allied Health Professional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "92EA2F9B-CB9B-EC11-80F1-005056B150D4",
                "course_category_name": "Emergency Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6063707-5F83-F011-999D-005056A726F7",
                "course_category_name": "ED Pathway Complete [Manage Publishing with Content Package]",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B6A16FEA-CB9B-EC11-80F1-005056B150D4",
                "course_category_name": "Emergency Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7064D866-23C9-E511-8771-005056B104B1",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C52374F4-5BD1-EC11-80EF-005056B176BA",
                "course_category_name": "ENA - Emergency Severity Index",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9E543B79-437D-F011-999C-005056A7C0C7",
                "course_category_name": "Clinical ED Continuing Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "67818377-3FCD-EC11-80F1-005056B1202E",
                "course_category_name": "ENA -  Emergency Severity Index",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "zRemoved-Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C5AEB8CE-5E83-F011-999D-005056A726F7",
                "course_category_name": "ED Pathway [Manage Publishing with Content Package]",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F4989EC3-516C-EE11-9984-005056A76043",
                "course_category_name": "ENA: Triage Curriculum [manage subscribers with Content Package]",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Medicine",
                "is_system_course_category": null
            },
            {
                "course_category_id": "888EE184-437D-F011-999C-005056A7C0C7",
                "course_category_name": "Triage",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6E2117C1-CB9B-EC11-80F1-005056B150D4",
                "course_category_name": "Emergency Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "31F57D8C-437D-F011-999C-005056A7C0C7",
                "course_category_name": "Onboarding",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C1BFF168-437D-F011-999C-005056A7C0C7",
                "course_category_name": "ED Pathway",
                "is_system_course_category": null
            },
            {
                "course_category_id": "281B0C70-437D-F011-999C-005056A7C0C7",
                "course_category_name": "ED Pathway Complete",
                "is_system_course_category": null
            },
            {
                "course_category_id": "953E7EB4-536C-EE11-9984-005056A76043",
                "course_category_name": "ENA: The Emergency Severity Index (ESI), Adult and Pediatric Course (English Version)",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "<br />",
            "course_level_accreditation_statement": "The Emergency Nurses Association is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Provider Unit #P0232.\r\nThe Emergency Nurses Association is approved by the California Board of Registered Nursing, Provider #2322.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 5.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];